import {
  AnyAccountId,
  anyAccountId,
  RoomContextId,
  roomContextId,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomAccountDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomAccountDeleteRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomAccountDeleteRequestDTORaw) {
    JsonSchemaValidator.assert(RoomAccountDeleteRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accountId", "roomId", "roomContextId"],
      properties: {
        accountId: anyAccountId,
        roomId,
        roomContextId
      },
      additionalProperties: false
    };
  }
}

export interface RoomAccountDeleteRequestDTORaw {
  accountId: AnyAccountId;
  roomId: RoomId;
  roomContextId: RoomContextId;
}
